import { MrbBaseRouteStore } from "mrb/core";
import { OrderService } from "common/services";

class OrderPreviewRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(OrderService);
    }

    async getOrder(id) {
        const response = await this.service.get(id);
        return response.data;
    }
}

export default OrderPreviewRouteStore;
